import { render } from "./Project1View.vue?vue&type=template&id=6da5d5be&scoped=true&ts=true"
import script from "./Project1View.vue?vue&type=script&lang=ts"
export * from "./Project1View.vue?vue&type=script&lang=ts"

import "./Project1View.vue?vue&type=style&index=0&id=6da5d5be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da5d5be"]])

export default __exports__